"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
const fontWeights = {
  "light": 300,
  "regular": 400,
  "medium": 500,
  "semiBold": 400,
  "bold": 700
};
exports.default = fontWeights;